import { createAction } from '../../../core/helpers'

import { FETCH_LOCATION_TYPE_CATEGORY } from '../action-types'

export const cleanupFetchLocationTypeCategory = createAction(
  FETCH_LOCATION_TYPE_CATEGORY.CLEANUP,
)
